var map = {
	"./home-entertainment.de-CH.json": 1551,
	"./home-entertainment.de-DE.json": 1552,
	"./home-entertainment.en-CA.json": 1553,
	"./home-entertainment.en-GB.json": 1554,
	"./home-entertainment.en-IN.json": 1555,
	"./home-entertainment.en-ME.json": 1556,
	"./home-entertainment.en-US.json": 1557,
	"./home-entertainment.es-EM.json": 1558,
	"./home-entertainment.es-ES.json": 1559,
	"./home-entertainment.fr-BE.json": 1560,
	"./home-entertainment.fr-CA.json": 1561,
	"./home-entertainment.fr-CH.json": 1562,
	"./home-entertainment.nl-BE.json": 1563,
	"./home-entertainment.nl-NL.json": 1564,
	"./home-entertainment.pl-PL.json": 1565,
	"./home-entertainment.pt-BR.json": 1566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1550;